import React from 'react';

const AccountSetting = ({ UserData, PopStyle }) => {

  var dropdown = {
    display: 'block',
    width: '100%',
    padding: '8px 12px 8px 30px',
    clear: 'both',
    fontWeight: '400',
    color: '#212529',
    textAlign: 'inherit',
    whiteSpace: 'nowrap',
    border: 0,
  }


  return (
    <div style={PopStyle} className="accountSettingWrapper">
      <div className="border-0 show"
        style={{
          position: 'fixed',
          margin: '0px 0px 10px 5px',
          boxShadow: '0 8px 16px rgb(0 0 0 / 39%)',
          background: '#fff'
        }}>
        <div className="noHover" style={{ cursor: 'pointer' }}>
          <span className="material-icons DropDownIcon">manage_accounts</span>
          <div style={dropdown}>
            <span style={{ marginLeft: '15px' }}>{UserData.email}</span>
          </div>
        </div>
        <div className="noHover" style={{ cursor: 'pointer' }}
          onClick={() => {
            localStorage.clear()
            window.location.reload(false)
          }}
        >
          <span className="material-icons DropDownIcon">logout</span>
          <div style={dropdown}>
            <span style={{ marginLeft: '15px' }}>Logout</span>
          </div>
        </div>
      </div>
    </div>
  );
};


export default AccountSetting;